import { Formik, Form } from 'formik';
import { GoSearch } from 'react-icons/go';
import styled from 'styled-components';
import { Input } from '../../../../components/Input';

const Container = styled.div`
  margin-right: 0.75rem;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 0.5rem;
    max-width: 170px;
  }
`;

export const Search = () => (
  <Container>
    <Formik
      initialValues={{ value: '' }}
      onSubmit={() => console.log('enviando dados')}
    >
      <Form>
        <Input
          type="email"
          thickness="sm"
          name="email"
          noMargin
          icon={GoSearch}
          placeholder="Faça sua pesquisa"
        />
      </Form>
    </Formik>
  </Container>
);
